var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatrWordmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123,
    height: 12,
    viewBox: "0 0 123 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__a",
    d: "M0 0h25.098v12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__c",
    d: "M0 0h2.201v7.49H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__e",
    d: "M0 0h21.552v11.997H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.288 12h1.81L13.406.354a1.213 1.213 0 0 0-1.713 0L0 12h1.81c.83 0 1.626-.329 2.214-.915l7.91-7.878c.34-.339.89-.339 1.23 0l7.91 7.878a3.137 3.137 0 0 0 2.214.915"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.762)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.81 0H0l11.693 11.646a1.213 1.213 0 0 0 1.712 0L25.098 0h-1.81c-.83 0-1.626.329-2.214.915l-7.91 7.878c-.34.339-.89.339-1.23 0L4.024.915A3.137 3.137 0 0 0 1.81 0",
    mask: "url(#logo_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.124 4.51)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.201 6.93V.56A.559.559 0 0 0 1.641 0H.56A.559.559 0 0 0 0 .559V6.93c0 .309.25.559.559.559h1.083c.309 0 .56-.25.56-.56",
    mask: "url(#logo_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M96.092 2.19 94.812.918a3.148 3.148 0 0 0-2.22-.915H72.357l1.28 1.272a3.15 3.15 0 0 0 2.22.915h9.769zM72.782 12h1.81L62.899.354a1.213 1.213 0 0 0-1.713 0L49.493 12h1.81c.83 0 1.626-.329 2.215-.915l7.909-7.878c.34-.339.89-.339 1.231 0l7.91 7.878a3.137 3.137 0 0 0 2.214.915"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.934 .003)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.122 6.804c1.946 0 3.514-1.607 3.427-3.556C21.467 1.412 19.877 0 18.035 0H0l1.283 1.272a3.16 3.16 0 0 0 2.224.915H18.047c.642 0 1.22.468 1.277 1.106a1.22 1.22 0 0 1-1.22 1.324H.56a.56.56 0 0 0-.56.559v6.262c0 .309.25.56.56.56h1.086c.309 0 .56-.251.56-.56V6.804h10.99l4.313 4.27a3.16 3.16 0 0 0 2.231.923h1.813l-5.238-5.193z",
    mask: "url(#logo_svg__f)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatrWordmark);
export default __webpack_public_path__ + "static/media/avatr-wordmark.048bc467af0340c93f23bfabe15e1963.svg";
export { ForwardRef as ReactComponent };